<template>
  <div id="nB">
    <v-dialog v-model="value" persistent width="85%">
      <v-card color="primary" style="border-radius: 33px;">
        <v-stepper v-model="e1" vertical>
          <v-stepper-step :complete="e1 > 1" :step="1">Datos Generales</v-stepper-step>
          <v-stepper-content :step="1">
            <v-form>
              <v-layout row wrap justify-center fill-height align-center>
                <h2
                  class="text-xs-center title"
                >Ingresa el nombre de la institución, recuerda que puedes modificarlo posteriormente</h2>
                <v-flex xs12 sm6>
                  <v-img :src="require('@/assets/onBoarding/SKLB-Colegio.png')"></v-img>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout row wrap justify-center fill-height align-center>
                    <v-flex xs12 sm7>
                      <v-text-field
                        v-model="$v.branchForm.name.$model"
                        label="Nombre de la institución"
                        outline
                        :error-messages="processBranchName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm7>
                      <v-text-field v-model="city" label="Ciudad o país" outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm7>
                      <v-btn small round flat @click="close">Cancelar</v-btn>
                      <v-btn dark small round color="gradiente" @click="next">Siguiente</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-stepper-content>
          <v-stepper-step :complete="e1 > 2" :step="2">Mapa</v-stepper-step>
          <v-stepper-content :step="2" style="padding: 0; margin: 0px;">
            <v-layout row wrap>
              <v-flex xs12>
                <GmapMap
                  :center="{ lat: 19.702559, lng: -101.192341 }"
                  :zoom="20"
                  ref="mapBoarding"
                  style="height: 600px; margin: 0px;"
                  :options="mapConfig"
                >
                  <v-toolbar
                    dense
                    color="transparent"
                    floating
                    id="toolbarBoarding2"
                    class="titleSearch elevation-0"
                  >
                    <v-text-field
                      class="mx-3 mt-4"
                      @keyup.enter="searchName"
                      label="Buscar"
                      prepend-inner-icon="search"
                      clearable
                      solo
                      v-model="search"
                    ></v-text-field>
                  </v-toolbar>
                </GmapMap>
              </v-flex>
            </v-layout>
          </v-stepper-content>
        </v-stepper>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapSettings } from "@/Catalogs/mapSettings";
import { gmapApi } from "vue2-google-maps";
export default {
  props: ["value"],
  validations: {
    branchForm: {
      name: { required }
    }
  },
  data: () => ({
    e1: 0,
    city: "",
    branchForm: {
      name: ""
    },
    search: ""
  }),
  methods: {
    close() {
      this.$emit("input", false);
    },
    next() {
      if (this.e1 == 1) {
        this.$v.branchForm.$touch();
        if (!this.$v.branchForm.$invalid) {
          this.e1++;
        }
      }
    }
  },
  computed: {
    processBranchName() {
      const errors = [];
      if (!this.$v.branchForm.name.$dirty) return errors;
      !this.$v.branchForm.name.required &&
        errors.push("El nombre de la institución es requerido");
      return errors;
    },
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings
      };
    },
    markerBranchIcon() {
      return {
        url: require("@/assets/mapIcons/if_graduation-cap_3688484.png"),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0)
      };
    }
  }
};
</script>

<style>
#nB > .v-dialog {
  border-radius: 33px !important;
}
</style>
